export const LOOKER_AGENT_PAGE_KEYS = {
	RARE_CHAT_BOT: "RARE_CHAT_BOT",
	LOOKER_AGENT: "LOOKER_AGENT",
};

export const LOOKER_AGENT_IDS = {
	[LOOKER_AGENT_PAGE_KEYS.RARE_CHAT_BOT]: "769018ebed6d44579abbba4504ee2d0c",
	[LOOKER_AGENT_PAGE_KEYS.LOOKER_AGENT]: "769018ebed6d44579abbba4504ee2d0c",
};

const rawLookerBaseUrl = (process.env.REACT_APP_LOOKER_BASE_URL || "").trim();
const legacyLookerChatBotUrl = (process.env.REACT_APP_LOOKER_CHAT_BOT_URL || "").trim();
const legacyLookerAgentUrl = (process.env.REACT_APP_LOOKER_AGENT_URL || "").trim();
const defaultLookerBaseUrl = "https://rarerabbitlooker.cloud.looker.com";

const getBaseUrlFromLegacyUrl = (url) => {
	if (!url) return "";

	try {
		const parsedUrl = new URL(url);
		return parsedUrl.origin;
	} catch {
		return "";
	}
};

const getConfiguredLookerBaseUrl = () => {
	return rawLookerBaseUrl || getBaseUrlFromLegacyUrl(legacyLookerAgentUrl) || getBaseUrlFromLegacyUrl(legacyLookerChatBotUrl) || defaultLookerBaseUrl;
};

const getAgentIdFromUrl = (url) => {
	if (!url) return "";

	try {
		const parsedUrl = new URL(url);
		return parsedUrl.searchParams.get("ds.agent") || "";
	} catch {
		return "";
	}
};

export const getLookerAgentId = (pageKey = LOOKER_AGENT_PAGE_KEYS.RARE_CHAT_BOT) => {
	const mappedAgentId = LOOKER_AGENT_IDS[pageKey] || LOOKER_AGENT_IDS[LOOKER_AGENT_PAGE_KEYS.RARE_CHAT_BOT] || "";
	if (mappedAgentId) return mappedAgentId;

	return getAgentIdFromUrl(legacyLookerAgentUrl) || getAgentIdFromUrl(legacyLookerChatBotUrl) || "";
};

export const getLookerConversationUrl = ({ pageKey = LOOKER_AGENT_PAGE_KEYS.LOOKER_AGENT, embed = false, agentId } = {}) => {
	const selectedAgentId =
		agentId === "" ? "" : agentId || getLookerAgentId(pageKey);
	const lookerBaseUrl = getConfiguredLookerBaseUrl();
	if (!lookerBaseUrl) return "";
	if (agentId !== "" && !selectedAgentId) return "";

	try {
		const url = new URL(embed ? "/embed/conversations" : "/conversations", lookerBaseUrl);
		if (selectedAgentId) {
			url.searchParams.set("ds.agent", selectedAgentId);
		}
		return url.toString();
	} catch {
		return "";
	}
};
